/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ADMIN_CAN_ABILITY = [
  //Route Access
  ['read', 'MyProfile'],
  ['read', 'OrgProfile'],
  ['read', 'DashboardOverview'],
  ['read', 'DashboardIssuerAnalysis'],
  ['read', 'DashboardVerifierAnalysis'],
  ['read', 'UsersList'],
  ['read', 'HoldersGroups'],
  ['read', 'HoldersGroups.Holders'],
  ['read', 'Holders'],
  ['read', 'ListedCredential'],
  ['read', 'Credential'],
  ['read', 'ViewCredential'],
  ['read', 'HoldersBatchImport'],
  ['read', 'IssuedCredentialList'],
  ['read', 'CredentialList'],
  ['read', 'IssueNewCredential'],
  ['read', 'IssuedNetworkGraph'],
  ['read', 'CreateCredentialTemplate'],
  ['read', 'Placeholder'],
  ['read', 'Templates'],
  ['read', 'IssueCredential'],
  ['read', 'PortfolioTemplate'],
  ['read', 'CreatePortfolioTemplate'],
  ['read', 'PortfolioTemplates'],
  ['read', 'PortfolioUnderReview'],
  ['read', 'CertificateUnderReviewPage'],
  ['read', 'CreatedEPortfolio'],
  ['read', 'ListedHolderEPortfolio'],
  ['read', 'ReviewedEPortfolio'],
  ['read', 'PortfoliosForReview'],
  ['read', 'CertificateForReview'],
  ['read', 'ReviewEPortfolio'],
  ['read', 'ApproveEPortfolio'],
  ['read', 'VerifyPortfolioCredential'],
  ['read', 'SelfAttestedTemplates'],
  ['read', 'IssueNewSelfAttestedCredential'],
  ['read', 'SelfAttestedUnderReviewTemplates'],
  ['read', 'SelfAttestedUnderReviewCredential'],
  ['read', 'SelfAttestedUnderReviewCredentials'],
  ['read', 'AttestCredentialReviewList'],
  ['read', 'AttestCredentialLists'],
  ['read', 'AttestCredentialList'],
  ['read', 'AttestedCredential'],
  ['read', 'PortfolioUnderApproval'],
  ['read', 'PortfoliosForApproval'],
  ['read', 'ListedPortfolio'],
  ['read', 'ListedEPortfolio'],
  ['read', 'ListedEPortfolioCertTemplates'],
  ['read', 'ListedEPortfolioCertificates'],
  ['read', 'PortfolioCertTemplates'],
  ['read', 'ApproveEPortfolioCredentials'],
  ['read', 'ReviewReqEPortfolioCertificates'],
  ['read', 'ApprovedEPortfolio'],
  ['read', 'ApprovedEPortfolioCertificates'],
];

export const ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
